<template>
  <div class="category-info-block">
    <v-expansion-panels v-model="panel" flat tile multiple>
      <v-expansion-panel v-if="!hideAbout && !isSuggested">
        <v-expansion-panel-header class="category-info-header pb-4">
          {{ $t('CategoryPage.about.label') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <CategoryInfo :category="category" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel
        class="category-info-content"
        :class="{ 'one-block': isSuggested }"
      >
        <v-expansion-panel-header
          class="category-info-header  pb-4"
          :class="{ 'pt-4': !isSuggested }"
        >
          <div class="d-flex flex-row">
            <div class="me-1">{{ $t('CategoryPage.authors.label') }}</div>
            <div class="author-number">({{ numberAuthors }})</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <CategoryAuthorInfo
            :category="category"
            @calcAuthors="handleCalcAuthors"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="!isSuggested" class="category-info-content">
        <v-expansion-panel-header class="category-info-header pt-4 pb-4">
          {{ $t('CategoryPage.quotes.label') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <CategoryQuote :category="category" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div
      v-if="!isDevice"
      class="donate-block d-flex align-center justify-center"
      :class="{ ocean: isOcean, ffa: !isOcean }"
    >
      <div
        class="donate-card d-flex flex-column align-center justify-center pt-3 pb-3 pl-5 pr-5"
      >
        <div class="donate-card-title pb-4">Support our project</div>
        <div class="donate-card-content pb-4">
          You can invest in the development of our project as a one-time
          donation or through monthly payments. Help us improve our product for
          you
        </div>
        <DonationControl
          class="px-8"
          x-large
          color="var(--primary-color)"
          :text-color="'#FFF'"
          :control-label="donationControlLabel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CategoryInfo from '@/components/views/CategoryView/CategoryInfo/CategoryInfo.vue';
import CategoryAuthorInfo from '@/components/views/CategoryView/CategoryAuthorInfo/CategoryAuthorInfo.vue';
import CategoryQuote from '@/components/views/CategoryView/CategoryQuote/CategoryQuote.vue';
import DonationControl from '@/components/controls/DonationControl/DonationControl.vue';

import BrandsEnum from '@shared/enums/BrandsEnum.mjs';
import CustomCategoriesEnum from '@shared/enums/CustomCategoriesEnum';

export default {
  name: 'DiscoveryBlock',
  components: {
    CategoryInfo,
    CategoryAuthorInfo,
    CategoryQuote,
    DonationControl
  },
  props: {
    hideAbout: Boolean,
    category: {
      type: String,
      required: false
    }
  },
  data() {
    const isDevice = this.$store.getters['ContextStore/isDevice'];

    return {
      isDevice,
      donationControlLabel: this.$t('App.Button.label.Donate'),
      panel: [0, 1, 2],
      numbAuthors: 0
    };
  },
  computed: {
    isSuggested() {
      return this.category === CustomCategoriesEnum.SUGGESTED_BOOK;
    },
    isOcean() {
      const brand = this.$store.getters['ContextStore/brand'];
      return brand === BrandsEnum.OCEAN;
    },
    numberAuthors() {
      if (process.server) {
        const authors = this.$store.getters[
          'LibraryStore/getServerSideCategoryAuthorList'
        ];
        return authors.length;
      }
      return this.numbAuthors;
    }
  },
  methods: {
    handleCalcAuthors(numberAuthors) {
      this.numbAuthors = numberAuthors;
    }
  }
};
</script>

<style lang="less" src="./DiscoveryBlock.less"></style>
